/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';

import { openIcon, closeIcon } from '@/assets';

interface FaqItem {
  question: string;
  answer: string;
}

export const FAQ: React.FC = () => {
  const [faqData] = useState<FaqItem[]>([
    {
      question: 'What is AWAP INVESTORS LTD all about?',
      answer:
        'AWAP INVESTORS LTD is a global digital real estate ecosystem where both low- and high-income earners can participate in real estate investment through AWAP Project Slots and Units. Our Digital Real Estate Market enables users to buy and sell landed properties securely and conveniently from anywhere in the world.',
    },
    {
      question: 'Is AWAP INVESTORS LTD registered and legal?',
      answer:
        'Yes. AWAP INVESTORS LTD is officially registered with the Corporate Affairs Commission (CAC) of Nigeria. We also hold an EFCC SCUML Certificate and are licensed by the Nigerian Export Promotion Council (NEPC), demonstrating our commitment to operating in compliance with applicable Nigerian laws and regulatory requirements.',
    },
    {
      question: 'How can I register and participate?',
      answer:
        "You can register by obtaining a referral link from your sponsor/upline or by clicking the Sign Up button on our website. Complete the registration form with your correct details, verify your email address, and log in to your account. Fund your wallet through a direct deposit or transfer to the company and start investing by purchasing our real estate properties, Project slots and Project Units. You can also activate your E-Realtor's account with ₦10,000 to unlock all the massive bonuses, commissions and incentives.",
    },
    {
      question: 'How does the Real Estate Market work?',
      answer:
        'Create and activate your account, fund your wallet, then visit our Real Estate Market to browse and purchase available landed properties. Our market is backed by real properties and operates in real time. After purchasing a property, investors can hold it, resell it through the platform, or develop it where applicable, while benefiting from potential value appreciation in both the platform and the underlying real estate market.',
    },
    {
      question: `What are the company's projected returns or profits for users?`,
      answer:
        'AWAP INVESTORS LTD does not guarantee or promise fixed returns on investments. Returns, bonuses, and incentives vary depending on the appreciation rate or project you participate in and are subject to the applicable terms and conditions. The value of Awap Project Unit on our platform is intended to reflect the performance and value of the underlying real-world assets, which may increase or decrease over time.',
    },
    {
      question: 'What is the minimum amount required to participate?',
      answer:
        'AWAP INVESTORS LTD offers inclusive opportunities that make real estate participation accessible to everyone. The minimum amount required to purchase our real estate properties and Project Slots varies depending on the specific property or project slot. However, with ₦1,000 and above, you can purchase Awap Project Units. To become an E-Realtor, the activation fee is ₦10,000, which gives you access to available bonuses, incentives, and commissions under the E-Realtor program.',
    },
    {
      question: 'How can I withdraw or cash out my funds?',
      answer:
        "You can withdraw your available funds directly to your bank account or cryptocurrency wallet using the platform's Cash Out feature. You may also transfer funds to another user within the platform, subject to the applicable terms and conditions. Cash-out requests can be submitted at any time. However, disbursements to external bank accounts or cryptocurrency wallets are processed on the last Friday of every month. The minimum cash-out amount is ₦20,000.",
    },
    {
      question:
        'What is the difference between Awap Project Slots (APS) and Awap Project Units (APU), and how can I participate?',
      answer:
        "AWAP Project Units (APU) are the digital, decentralized representation of participation across the company's projects. Their value is designed to grow based on the overall performance and net profits generated from Awap Project Slots and other qualifying activities. APU is intended to appreciate by 5% per month, subject to evaluation from the company net profit. Awap Project Slots (APS) provide direct participation in specific company projects. By purchasing a Project Slot, participants acquire a portion of a selected project and become eligible for the projected returns and duration specified for that project. To participate, simply create and activate your account, fund your wallet, and purchase either Awap Project Units or Slots based on your preferred participation option.",
    },
    {
      question:
        'Do AWAP INVESTORS LTD have a referral system, and what are the rewards?',
      answer:
        "AWAP INVESTORS LTD offers an optional Referral System designed to reward only E-Realtors who help to grow our community. E-Realtors gain access to our Builders Reward System (BRS), which includes: 8% sales commission from the real estate market, Builders Bonus — Earn ₦30,000 worth of Awap Project Units for referring 5 active E-Realtors, Referral Bonus — Earn 8% of your direct referral's first purchase, Team Bonus — Earn 2% of your downline's subsequent purchase for a lifetime, Networkers' Ranks & Incentives — Unlock exclusive rewards and special incentive packages as you progress through ranks and netpoints.",
    },
    {
      question: 'What is the company loan interest rate, and how do I apply?',
      answer:
        'AWAP INVESTORS LTD offers loans to eligible users based on their qualification and loan eligibility status. Approved loans attract a monthly interest rate of 5%–10%, depending on the loan terms and durations. To apply: 1. Log in to your AWAP INVESTORS account. 2. Go to Finance on your dashboard. 3. Click Loan and check your available loan limit. 4. Complete and submit your loan application for review and approval.',
    },
    {
      question: 'What is Land Pay, and how does it work?',
      answer:
        "Land Pay is AWAP INVESTORS LTD's flexible land ownership plan that allows users to acquire land through weekly installment payments for up to one year, making land ownership more affordable and accessible.",
    },
    {
      question: 'How can I repay my loan?',
      answer:
        'Loan repayments are simple and flexible. AWAP INVESTORS LTD automatically deducts your monthly repayment from your Main Wallet based on your repayment schedule. Simply deposit or transfer sufficient funds into your Main Wallet before the due date. You can also choose to make manual repayments by selecting the month(s) you wish to repay in advance and completing the payment through your dashboard.',
    },
    {
      question:
        'What savings options does the company offer, and what are the interest rates?',
      answer:
        'AWAP INVESTORS LTD offers two savings options to help users achieve their financial goals: Fixed Savings Plan — Earn 3% interest per month for the selected savings duration; Regular Savings Plan — Save through automatic weekly deductions from your account. This plan is designed for disciplined savings and does not earn interest (0%). Choose the savings plan that best suits your financial objectives and savings preference.',
    },
    {
      question: 'How can I withdraw my savings?',
      answer:
        'You can withdraw your savings once your savings plan reaches maturity, either by completing the target amount or the selected savings duration, depending on your plan. When your savings matures, the Withdraw button will be enabled on your dashboard, allowing you to transfer your savings directly to your Main Wallet.',
    },
    {
      question:
        'What is the difference between the Main Wallet and the Reserved Capital Wallet?',
      answer:
        'The Main Wallet is your primary transaction wallet. It can be used to purchase Awap Project Slots (APS), buy landed properties, fund your savings, repay loans, and make other eligible transactions within the platform. Funds in the Main Wallet are also withdrawable to your local bank account or other supported external payment wallets. The Reserved Capital Wallet is dedicated to purchasing Awap Project Units (APU) directly from the company. Funds in this wallet can also be transferred and utilized for eligible transactions within the AWAP INVESTORS ecosystem. However, funds in the Reserved Capital Wallet are not directly withdrawable.',
    },
    {
      question:
        'How can I withdraw my Awap Project Units (APU) and Awap Project Slots (APS)?',
      answer:
        "Awap Project Units (APU) are traded through the Project Units Market within the platform. You can sell your APU by listing them on the market, where other investors can purchase them. You may also transfer your units directly to interested investors in exchange for cash. In some cases, the company may also buy back units using profits generated from its operations, subject to availability and company policy. Awap Project Slots (APS) become redeemable upon the completion of the project's duration. Once the investment reaches maturity, the Redeem button is automatically enabled on your dashboard, allowing you to redeem your project slots and have the proceeds credited directly to your Main Wallet.",
    },
    {
      question: 'How can I deposit or top up my AWAP INVESTORS wallet?',
      answer:
        "You can fund your AWAP INVESTORS wallet manually or automatically. Automatically: 1. Log in to your account. 2. Go to Menu and select deposit. 3. Enter the amount in naira and complete the payment using the provided steps in the system. Manually: Transfer funds to the company's designated bank account. After making the transfer, the admin will verify your payment and credit your account using your registered E-Wallet address.",
    },
  ]);

  const [searchTerm, setSearchTerm] = useState<string>('');
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  const toggleAccordion = (index: number) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  const filteredFaqData = faqData.filter((faq) =>
    faq.question.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className='max-w-lg mx-auto flex flex-col items-center w-full my-8'>
      <input
        type='text'
        placeholder='Search FAQs'
        className='w-[80%] py-2 px-4 mb-4 border-none shadow-all-sides rounded-full focus:outline-none focus:border-blue-400'
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <div className='w-full px-8 sm:px-0'>
        {filteredFaqData.map((item, index) => (
          <div key={index} className=''>
            <div
              className='flex items-center justify-between py-4 bg-white rounded-lg cursor-pointer'
              onClick={() => toggleAccordion(index)}
            >
              <div className='flex items-center font-semibold text-md text-indigo border-b-[1px]  w-full pb-2'>
                <img
                  src={index === activeIndex ? closeIcon : openIcon}
                  alt='icon'
                  className='mr-2 h-4 w-4'
                />
                {item.question}
              </div>
            </div>
            {activeIndex === index && (
              <div className='p4 '>
                <p className='text-gray-700'>{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
